/**
 * "Questions for me" (kanban 2a28d4c0): every open ask quality has for the
 * signed-in person, one place, reached from the portal's More menu. The same
 * card the inbox and Customers pages show, with an empty state here.
 *
 * Route: /portal/questions-for-me
 */
import { useEffect } from 'react';
import QualityAsksCard from '../../components/portal/qualityAsks/QualityAsksCard';
import { trackEvent } from '../../services/portalTracking';
import styles from './QuestionsForMePage.module.css';

export default function QuestionsForMePage() {
  useEffect(() => {
    trackEvent('view', 'questions_for_me');
  }, []);
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Questions for me</h1>
      <p className={styles.lede}>
        What the quality desk is waiting on you for. Merlin sends these for quality; answer here and it reaches them.
      </p>
      <QualityAsksCard title="Quality is waiting on you" surface="questions_for_me" showEmpty />
    </div>
  );
}
